export const allLanguages = ['en', 'es', 'de', 'pt', 'it', 'fr', 'ca'];
